export enum Pagesize
{
    Letter = 1,
    A4 = 2
}